import React from "react";
import RecentPost from "../cards/RecentPost";
import { Link } from "react-router-dom";

// Image \\
import avatar from "../../assets/images/postImg.svg";

// Style \\
import "../../assets/styles/sections/fullInfo.scss";
import "../../assets/styles/sections/recentPosts.scss";
import "../../assets/styles/sections/newsSection.scss";

// Icons \\
import { MdOutlineCalendarToday } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { FaArrowLeft } from "react-icons/fa6";
import { FaRegHeart } from "react-icons/fa6";
import { FaRegUser } from "react-icons/fa";
import { LuEye } from "react-icons/lu";

const FullInfo = () => {
  return (
    <section className="fullInfo">
      <div className="container">
        <div className="fullInfo_items">
          <div className="fullInfo_items_box">
            <div className="fullInfo_items_avatar">
              <img src={avatar} alt="avatar" />
            </div>

            <div className="card_items_info">
              <div className="data">
                <MdOutlineCalendarToday className="calendar" />
                <p>Monday 05, September 2021</p>
              </div>

              <div className="auth">
                <FaRegUser className="user" />
                <p>By Author</p>
              </div>

              <div className="watched">
                <LuEye className="eye" />
                <p>68</p>
              </div>
              <div className="liked">
                <FaRegHeart className="heart" />
                <p>86</p>
              </div>
            </div>

            <div className="fullInfo_items_title">
              <h2>A passion for putting patients first</h2>
            </div>

            <div className="fullInfo_items_desc">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Quisque placerat scelerisque tortor ornare
                ornare. Quisque placerat scelerisque tortor ornare ornare
                Convallis felis vitae tortor augue. Velit nascetur proin massa
                in. Consequat faucibus porttitor enim Lorem ipsum dolor sit
                amet, consectetur adipiscing elit. Quisque placerat scelerisque
                tortor ornare ornare. Quisque placerat scelerisque tortor ornare
                ornare Convallis felis vitae tortor augue. Velit nascetur proin
                massa in. Consequat faucibus porttitor enim Lorem ipsum dolor
                sit amet, consectetur adipiscing elit. Quisque placerat
                scelerisque tortor ornare ornare. Quisque placerat scelerisque
                tortor ornare ornare Convallis felis vitae tortor augue. Velit
                nascetur proin massa in. Consequat faucibus porttitor enim Lorem
                ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Quisque placerat scelerisque tortor ornare
                ornare. Quisque placerat scelerisque tortor ornare ornare
                Convallis felis vitae tortor augue. Velit nascetur proin massa
                in. Consequat faucibus porttitor enim et.
              </p>
            </div>

            <div className="readMore">
              <Link className="readMoreLink">
                <span>
                  <FaArrowLeft className="arrow-icon" />
                </span>
                Previous Article
              </Link>
              <Link className="readMoreLink next">
                Next Article
                <span>
                  <FaArrowRight className="arrow-icon" />
                </span>
              </Link>
            </div>
          </div>

          <div className="box">
            <RecentPost />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FullInfo;
